export class focusLabelModule {

    inputElement: NodeList = document.querySelectorAll('[data-input]');

    constructor() {
        this.focusLabel();
    }

    public focusLabel() {
        for (let i = 0; i < this.inputElement.length; i++) {

            const el = this.inputElement[i];

            el.addEventListener('focus', (e) => {
                const target: any = e.target;
                target.previousSibling.classList.add('is-focused');
            });

            el.addEventListener('blur', (e) => {
                const inputValue: any = e.target;

                if (inputValue.value === "") {
                    inputValue.previousSibling.classList.remove('is-focused');
                }
            });
        }
    }
}